import { IDetectionFeedbackData } from '@/shared/interfaces/DetectionFeedback';
import { axiosHttp } from '@/util/AxiosHttp';
import { Constants } from '@/shared/Constants';
import { signFeedbackService } from '@/shared/services/SignFeedbackService';

class DetectionFeedbackService {
    public async saveFeedback(feedbackData: IDetectionFeedbackData): Promise<string> {
        try {
            const isCorrect = Boolean(feedbackData.found_desired_gesture && feedbackData.selected_correct_result)
            const body: any = {
                type: isCorrect ? 'correct' : 'not_found',
                session_id: feedbackData.session_id || 'unknown',
                query_type: 'sign_to_text'
            }
            if (isCorrect) {
                body.sign_id = feedbackData.selected_correct_result!.signId
            }
            // Prefer updating by explicit log id if available
            const lastLogId = (signFeedbackService as any)?.lastLogId
            if (lastLogId) {
                body.id = lastLogId
            }
            const url = `${Constants.nodeBackendUrl}/api/logs/feedback`
            const resp = await axiosHttp.http.post(url, body)
            return resp.data?.id || 'ok'
        } catch (error) {
            // Surface original error
            console.error('Error saving detection feedback:', error)
            throw new Error('Failed to save feedback')
        }
    }
}

export const detectionFeedbackFirestoreService = new DetectionFeedbackService();
